import {
  GET_EVENT_PROFILE,
  GET_EVENT_PROFILE_FAIL,
  GET_EVENT_PROFILE_SUCCESS,
  GET_EVENTS,
  GET_EVENTS_FAIL,
  GET_EVENTS_SUCCESS,
  ADD_NEW_EVENT,
  ADD_EVENT_SUCCESS,
  ADD_EVENT_FAIL,
  UPDATE_EVENT,
  UPDATE_EVENT_SUCCESS,
  UPDATE_EVENT_FAIL,
  DELETE_EVENT,
  DELETE_EVENT_SUCCESS,
  DELETE_EVENT_FAIL,
  GET_EVENTS_BY_CLIENT_ID,
} from "./actionTypes"

export const getEvents = ({ is_active, offset='', page_size='' }) => ({
  type: GET_EVENTS,
  payload: { is_active, offset, page_size },
})
export const getEventsById = ({ is_active, client_id, offset, page_size }) => ({
  type: GET_EVENTS_BY_CLIENT_ID,
  payload: { is_active, client_id, offset, page_size },
})

export const getEventsSuccess = events => ({
  type: GET_EVENTS_SUCCESS,
  payload: events,
})

export const getEventsFail = error => ({
  type: GET_EVENTS_FAIL,
  payload: error,
})

export const addNewEvent = (event,history) => ({
  type: ADD_NEW_EVENT,
  payload: {event,history},
})

export const addEventSuccess = user => ({
  type: ADD_EVENT_SUCCESS,
  payload: user,
})  

export const addEventFail = error => ({
  type: ADD_EVENT_FAIL,
  payload: error,
})

export const updateEvent = (event,history) => ({
  type: UPDATE_EVENT,
  payload: {event,history},
})

export const updateEventSuccess = user => ({
  type: UPDATE_EVENT_SUCCESS,
  payload: user,
})

export const updateEventFail = error => ({
  type: UPDATE_EVENT_FAIL,
  payload: error,
})

export const deleteEvent = user => ({
  type: DELETE_EVENT,
  payload: user,
})

export const deleteEventSuccess = user => ({
  type: DELETE_EVENT_SUCCESS,
  payload: user,
})

export const deleteEventFail = error => ({
  type: DELETE_EVENT_FAIL,
  payload: error,
})

export const getEventProfile = () => ({
  type: GET_EVENT_PROFILE,
})

export const getEventProfileSuccess = userProfile => ({
  type: GET_EVENT_PROFILE_SUCCESS,
  payload: userProfile,
})

export const getEventProfileFail = error => ({
  type: GET_EVENT_PROFILE_FAIL,
  payload: error,
})
